<style lang="scss">
@import "@/styles/index.scss";
</style> 
<template>
    <div ref="appvue">
        <v-app>
            <v-main :class="{'myt-user':checkCustomInstitute()}">
                <router-view></router-view>
                <v-overlay :value="$root.showLoader" :z-index="$root.showLoaderIndex">
                    <img src="./assets/img/loader.gif" class="loader-gif" />
                </v-overlay>
                <FloatingChatButton v-if="showFloatingButton" />
            </v-main>
        </v-app>
    </div>
</template>


<script>
import { mapMutations, mapState } from "vuex";
import constants from "@/utils/constants";
import FloatingChatButton from "@/components/ChatAI/FloatingChatButton.vue";
export default {
    name: "App",
    components: { FloatingChatButton },
    data: () => ({
        pageHeight: "100vh"
    }),
    mounted() {
        let height = this.$refs.appvue.clientHeight;
        let width = this.$refs.appvue.clientWidth;
        if(width>667){
            this.pageHeight = height + "px";
        }
        else{
            this.pageHeight = height - 66 + "px";
        }        
        var elem = document.getElementsByClassName("v-application--wrap");
        if(elem && elem.length){
            elem[0].style.minHeight = this.pageHeight;
            if(elem[1] && elem[1].style){
               elem[1].style.minHeight = this.pageHeight;
            }
        }
        
        this.getShowLogoStatus();
        //adding node version changes
    },
    methods: {
        ...mapMutations("userStore", ["updateIsDefaultInstitute"]),
        getShowLogoStatus() {
            let isDefaultInstitute = this.checkIsDefaultInstitute();
            this.updateIsDefaultInstitute(isDefaultInstitute);
            this.setPageTitle(isDefaultInstitute);
        },
        checkCustomInstitute() {
            return this.myInstitute?this.CUSTOM_INSTITUTE_ID.includes(this.myInstitute.id):false
        },
    },
    computed:{
        ...mapState("userStore", ["user", "pendingTestList",'myInstitute']),
        showFloatingButton() {
            return (
                this.user &&
                this.myInstitute &&
                [constants.ROLES_ID.CO, constants.ROLES_ID.ID, constants.ROLES_ID.TR].includes(this.user.role_id) &&
                constants.AITS_INSTITUTE_ID.includes(this.myInstitute.id)
            );
        }
    }
};
</script>
<style lang="scss">
@import "@/styles/index.scss";
</style> 